// uproot-landing.js — reimplementación vanilla (sin jQuery/Slick) de las 2 piezas interactivas
// de la landing advertorial: (1) carrousel de imágenes de producto con flechas (mismas clases CSS
// que generaba Slick en la fuente: .slick-slide/.slick-prev/.slick-next/.slick-dots — así el CSS
// verbatim de la fuente sigue aplicando tal cual); (2) fecha del "Posted By".
(function () {
  function initSlider() {
    var wrap = document.querySelector(".product_slide-div");
    if (!wrap) return;
    var slides = Array.prototype.slice.call(wrap.children);
    if (!slides.length) return;
    slides.forEach(function (s, i) {
      s.classList.add("slick-slide");
      s.style.display = i === 0 ? "block" : "none";
    });
    var prev = document.createElement("button");
    prev.type = "button";
    prev.className = "slick-prev";
    prev.setAttribute("aria-label", "Previous");
    var next = document.createElement("button");
    next.type = "button";
    next.className = "slick-next";
    next.setAttribute("aria-label", "Next");
    wrap.appendChild(prev);
    wrap.appendChild(next);
    var dotsWrap = document.createElement("ul");
    dotsWrap.className = "slick-dots";
    slides.forEach(function (_, i) {
      var li = document.createElement("li");
      if (i === 0) li.className = "slick-active";
      var b = document.createElement("button");
      b.type = "button";
      b.textContent = String(i + 1);
      li.appendChild(b);
      li.addEventListener("click", function () { go(i); });
      dotsWrap.appendChild(li);
    });
    wrap.appendChild(dotsWrap);
    var idx = 0;
    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.style.display = i === idx ? "block" : "none"; });
      Array.prototype.forEach.call(dotsWrap.children, function (li, i) {
        li.classList.toggle("slick-active", i === idx);
      });
    }
    prev.addEventListener("click", function () { go(idx - 1); });
    next.addEventListener("click", function () { go(idx + 1); });
  }

  function initPostDate() {
    var el = document.querySelector(".up-postdate");
    if (!el) return;
    // freshness dinámica tipo Funnelish getDate(0): horas desde medianoche local.
    var h = new Date().getHours();
    el.textContent = h < 1 ? "Just now" : h + (h === 1 ? " hour ago" : " hours ago");
  }

  function initYear() {
    var el = document.querySelector(".footer_text span");
    if (el) el.textContent = new Date().getFullYear();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ready);
  } else {
    ready();
  }
  function ready() {
    initSlider();
    initPostDate();
    initYear();
  }
})();
